import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/packages/utils";

const brandAssetSrc = {
  icon: "/brand/icon.svg",
  logo: "/brand/logo-with-text.svg",
} as const;

interface BrandAssetProps extends ComponentPropsWithoutRef<"img"> {
  variant?: keyof typeof brandAssetSrc;
}

export function BrandAsset({
  alt = "Audinero",
  className,
  draggable = false,
  variant = "logo",
  ...props
}: BrandAssetProps) {
  return (
    <img
      alt={alt}
      className={cn("block shrink-0 select-none", className)}
      draggable={draggable}
      src={brandAssetSrc[variant]}
      {...props}
    />
  );
}
